import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import {
  PatientFormComponent,
} from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import { createNewPatient } from 'src/clinic/utils/patientUtils'
import {
  isPatientEmailValid,
  isPatientMobileValid,
} from 'src/clinic/components/ClinicManageBookingsPage/newBookingCalendarUtils'
import { hasValidPatientAgeInput } from 'src/clinic/components/ClinicManageBookingsPage/patientForm/utils/patientAgeUtils'
import { BLANK_PATIENT_DATA, PATIENT_VALIDATION_FIELDS } from 'src/consumer/constants'

export default function NewPatientForm({
  closeDialog,
  clinicId,
  clinicBrandId,
  clinicBrandData,
  mentorProfileData,
  setSelectedPatient,
  afterAddPatientFunction = (patInfo) => {
    console.log('savedPatient', patInfo)
  },
  createPatientApiSignature,
  patientSearchApiSignature,
}) {
  const [patientToSave, setPatientToSave] = useState({ ...BLANK_PATIENT_DATA })
  const [makeAnonymousPatient, setMakeAnonymousPatient] = useState(false)
  const [saving, setSaving] = useState(false)
  const [newPatientInputDataValidations, setNewPatientInputDataValidations] =
    useState(PATIENT_VALIDATION_FIELDS)

  const createPatient = async () => {
    await createNewPatient(
      clinicId,
      clinicBrandId,
      mentorProfileData,
      patientToSave,
      setSaving,
      false,
      afterAddPatientFunction,
      setPatientToSave,
      () => {},
      () => {},
      () => {},
      makeAnonymousPatient,
      createPatientApiSignature,
      patientSearchApiSignature,
    )
    closeDialog()
  }
  useEffect(() => {
    setNewPatientInputDataValidations({
      ...PATIENT_VALIDATION_FIELDS,
      name: Boolean(patientToSave?.name),
      email: isPatientEmailValid(patientToSave, makeAnonymousPatient),
      mobile: isPatientMobileValid(patientToSave, makeAnonymousPatient),
      gender: Boolean(patientToSave?.gender),
      age: hasValidPatientAgeInput(patientToSave),
    })
  }, [patientToSave, makeAnonymousPatient])

  console.log({ newPatientInputDataValidations })

  return (
    <>
      <DialogTitle>Create a new patient</DialogTitle>
      <DialogContent>
        <PatientFormComponent
          patientDetails={patientToSave}
          patientInputDataValidations={newPatientInputDataValidations}
          setPatientDetails={setPatientToSave}
          onFindingExistingPatient={(existingPatient) => {
            setSelectedPatient(existingPatient)
            closeDialog()
          }}
          editMode
          hidePatientNumber
          makeAnonymousPatient={makeAnonymousPatient}
          setMakeAnonymousPatient={setMakeAnonymousPatient}
          patientSearchApiSignature={patientSearchApiSignature}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="unFocused"
          variant="outlined"
          onClick={() => {
            closeDialog()
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={
            !(
              newPatientInputDataValidations?.name &&
              (newPatientInputDataValidations?.email || newPatientInputDataValidations?.mobile) &&
              newPatientInputDataValidations?.gender &&
              newPatientInputDataValidations?.age
            )
          }
          variant="contained"
          onClick={createPatient}
        >
          Create{' '}
          {saving && (
            <CircularProgress
              sx={{ height: '24px!important', width: '24px!important', color: 'grey', ml: 3 }}
            />
          )}
        </Button>
      </DialogActions>
    </>
  )
}
